import { errorText } from "../../i18n/serverErrors";
import { t as translate } from "../../i18n/t";
import type { ResolvedPrinter } from "../../platform/printerRegistry";
import type { ItemStickerPrint } from "./printItemSticker";

/**
 * G-130 — what a person reads after a sticker print, in ONE place. The item
 * card said these words itself (G-100); the receiving row now prints the same
 * sticker, and two copies of "which printer, which failure" would drift.
 *
 * `notice` is the good news (printed — on which machine); `error` is what
 * went wrong, or the too-narrow warning reported AFTER a print that did go
 * out (it cannot fire on this shop's 384-dot paper, and a gate would put back
 * the confirmation G-100 removed).
 */
export function itemStickerOutcomeText(
  result: ItemStickerPrint,
  printer: ResolvedPrinter,
): { notice: string | null; error: string | null } {
  if (result.outcome === "printed") {
    return {
      notice: printer.shared
        ? translate("itemSticker.printedOnShared", {
            printer: printer.printer.name ?? translate("note.thePrinter"),
          })
        : translate("itemSticker.printed"),
      error: result.tooNarrow ? translate("print.paperTooNarrow") : null,
    };
  }
  if (result.outcome === "could-not-draw") {
    return { notice: null, error: errorText(result.cause, "itemSticker.couldNotDraw") };
  }
  return { notice: null, error: errorText(result.cause, "itemSticker.couldNotPrint") };
}
